import type { AppLocale, MessageTree } from "@airange/shared/i18n-common";
import { redblueCommonMessages } from "./common";
import { redblueFormMessages } from "./forms";
import { mergeLocaleCatalogSlices } from "./merge-message-tree";
import { redblueActivityPageMessages } from "./pages-activities";
import { redblueMemberAuthPageMessages } from "./pages-members-auth";
import { redblueSchemePageMessages } from "./pages-schemes";
import { redblueWorkbenchPageMessages } from "./pages-workbenches";

const redblueCatalogSlices: Array<Record<AppLocale, MessageTree>> = [
  redblueCommonMessages,
  redblueFormMessages,
  redblueActivityPageMessages,
  redblueMemberAuthPageMessages,
  redblueSchemePageMessages,
  redblueWorkbenchPageMessages,
];

const redblueMessages = mergeLocaleCatalogSlices(redblueCatalogSlices);

export function getRedblueMessages(locale: AppLocale) {
  return redblueMessages[locale];
}
